import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, RoundedButton } from '@codametrix/ui-components';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch, useSelector } from 'react-redux';
import { acceptEula, cancelEula } from '../../actions/eula';
import gfm from 'remark-gfm';
import './acceptable-eula.scss';
import { cmxDateTime } from '@codametrix/ui-common';
const AcceptableEula = ()=>{
    const eula = useSelector((state)=>{
        return state.eula;
    });
    const { context, homepagePreference } = useSelector((state)=>{
        return state.ui;
    });
    const dispatch = useDispatch();
    const acceptEulaClick = ()=>{
        const datedEula = {
            ...eula.eula,
            acceptedDate: cmxDateTime.format(new Date(), cmxDateTime.FORMATS.DATE_TIME_EULA)
        };
        dispatch(acceptEula({
            eula: datedEula,
            context,
            homepagePreference
        }));
    };
    const footerChildren = /*#__PURE__*/ _jsxs("div", {
        className: 'columns',
        children: [
            /*#__PURE__*/ _jsxs(RoundedButton, {
                className: 'btn btn-primary qa-submit-button  column ',
                onClick: ()=>{
                    acceptEulaClick();
                },
                children: [
                    ' ',
                    "Accept"
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: 'column col-1'
            }),
            /*#__PURE__*/ _jsxs(RoundedButton, {
                className: 'btn btn-secondary qa-cancel-button column ',
                onClick: ()=>{
                    dispatch(cancelEula(true));
                },
                children: [
                    ' ',
                    "Cancel"
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsx("div", {
        className: 'qa-acceptable-eula acceptable-eula',
        children: /*#__PURE__*/ _jsx(Modal, {
            footerChildren: footerChildren,
            closable: false,
            title: 'CodaMetrix End User License Agreement',
            children: /*#__PURE__*/ _jsx(ReactMarkdown, {
                plugins: [
                    gfm
                ],
                children: eula.eula.text
            })
        })
    });
};
export default AcceptableEula;
